<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
				<FormItem label="标题" prop="title" class="sj">
					<Input v-model="formValidate.title" placeholder="请输入名称"></Input>
				</FormItem>
				
				<FormItem label="所属人" prop="their" class="sj">
					<Select v-model="formValidate.their" placeholder="所属人"  @on-change="onchange">
						<Option value="小捷智购">小捷智购</Option>
					</Select>
				</FormItem>
				<FormItem label="图片" prop="value" class="sj " >
					<div class="tupian" style="width: 700px;">
						<img   style="width: 200px;" v-for="(item,i) in formValidate.urlsStrings" :src="item"/>
					</div>
				</FormItem>
				<FormItem label="重新上传" class="">
					<Imgs @imgFile='imgFile' number='3' :url="url" />
				</FormItem>
				<FormItem label="内容" prop="value" class="sj">
					<Input v-model="formValidate.value" placeholder="请输入内容" show-word-limit type="textarea"></Input>
				</FormItem>

				<FormItem label="是否发布" prop="release" class="sj">
					<Select v-model="formValidate.release" placeholder="请选择是否必须更新">
						<Option value="shi">发布</Option>
						<Option value="fou">待发布</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Imgs from '@/components/comm/imgs.vue'
	export default {
		data() {
			return {
				url: '',
				formValidate: {
					title: '',
					their: '小捷智购',
					value:'',
					urls:'',
					release:''
				},
				ruleValidate: {
					title: [{
						required: true,
						message: '标题不能为空！！！',
						trigger: 'blur'
					}],
					their: [{
						required: true,
						message: '所属人不能为空！！！',
						trigger: 'blur'
					}],
					value: [{
						required: true,
						message: '内容不能为空！！！',
						trigger: 'blur'
					}],
					release: [{
						required: true,
						message: '是否发布！！！',
						trigger: 'blur'
					}]
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			imgFile(files) {
				console.log(files)
				this.formValidate.urls = files.substr(0, files.length - 1);
				if (this.formValidate.img.length > 0) {
					this.imgBool = false
				} else {
					this.imgBool = true
				}
			},
			handleSubmit(name) {
				let _this = this
				this.$refs[name].validate((valid) => {
					this.formValidate.createdTime = ''
					if (valid) {
						http.http({
							//这里是你自己的请求方式、url和data参数
							method: 'post',
							url: http.url + '/journalism/update',
							data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
							//假设后台需要的是表单数据这里你就可以更改
						})


					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},

		components: {
			Imgs
		},
		created() {
			let id = this.$route.query.id
			this.formValidate.id = id
			let _this = this
			_this.url=http.url+"/file/img/xinwen"
			http.http({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: http.url + '/journalism/get',
				data: {
					id: id
				},
				_this: _this,
				success: function(data) {
					_this.formValidate = data.journalismDto
				}
				//假设后台需要的是表单数据这里你就可以更改
			})

		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
	.tupian{
		display: flex;
		
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/xinwenzixun/update.vue